/**
 * Global navigation bridge for non-React contexts (command handlers, stores, services).
 *
 * React-router v6's `useNavigate` is only available inside React components. Command
 * handlers and store actions need a way to trigger SPA navigation without causing a
 * full page reload (which `window.location.href` does).
 *
 * Flow:
 *   1. Caller dispatches a `river:navigate` CustomEvent via `navigateTo(path, state?)`.
 *   2. A single listener in `App.tsx` (inside the Router) calls `useNavigate()(path, { state })`.
 *
 * This keeps navigation idiomatic (react-router owns history) while letting any module
 * in the app request navigation.
 */

export const RIVER_NAVIGATE_EVENT = 'river:navigate';

export interface RiverNavigateDetail {
  path: string;
  state?: Record<string, unknown>;
  replace?: boolean;
}

export function navigateTo(
  path: string,
  options: { state?: Record<string, unknown>; replace?: boolean } = {}
): void {
  window.dispatchEvent(
    new CustomEvent<RiverNavigateDetail>(RIVER_NAVIGATE_EVENT, {
      detail: { path, state: options.state, replace: options.replace },
    })
  );
}
